import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, alpha, useTheme } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import Dialog from '.';
import { FullSizeCenteredColumn } from '../FlexBox';

// How far from the scheduled time a recall still counts as on time, in minutes.
export const RECALL_TIME_TOLERANCE = 10;

/**
 * Asks before a recall is made away from its scheduled time. Open while `scheduledOn` is set.
 */
const RecallTimeDialog = function RecallTimeDialog({
  scheduledOn = null,
  onCancel,
  onSubmit,
}) {
  const intl = useIntl();
  const theme = useTheme();
  const warning = theme.palette.warning.main;

  return (
    <Dialog
      id="recall-time-dialog"
      open={Boolean(scheduledOn)}
      title="WARNING"
      titleColor={theme.palette.warning.dark}
      icon={<WarningAmberRoundedIcon sx={{ color: warning, fontSize: 32 }} />}
      onClose={onCancel}
      onCancel={onCancel}
      onSubmit={onSubmit}
      submitLabel="RECALL_ANYWAY"
      width="sm"
      fullWidth
      disableBackdropClick
      dividers
      styles={{
        title: {
          backgroundColor: alpha(warning, 0.12),
          borderTop: `6px solid ${warning}`,
        },
        actions: {
          '& #dialog-submit-btn': {
            backgroundColor: warning,
            color: theme.palette.warning.contrastText,
            '&:hover': { backgroundColor: theme.palette.warning.dark },
          },
        },
      }}
    >
      <FullSizeCenteredColumn padding="24px">
        <Typography variant="body1" sx={{ fontSize: '1.05rem', textAlign: 'center' }}>
          {scheduledOn
            ? intl.formatMessage(
                { id: 'RECALL_OUT_OF_TIME_QUESTION' },
                {
                  date: new Date(scheduledOn).toLocaleString(intl.locale, {
                    day: 'numeric',
                    month: 'long',
                    hour: '2-digit',
                    minute: '2-digit',
                  }),
                }
              )
            : ''}
        </Typography>
      </FullSizeCenteredColumn>
    </Dialog>
  );
};

export default RecallTimeDialog;
